<script setup lang="ts">
</script>

<template>
  <div class="flex items-center justify-center text-secondary h-40px">
    Copyright © 2021-{{ new Date().getFullYear() }} Tencent. All Rights Reserved
  </div>
</template>

<style scoped></style>
